// theme/presets/radius.ts — legacy radius migration table.
//
// Radius is now the numeric `radiusPx` pref (0–48px), driving radius.lg exactly and
// scaling sm/md by the same ratio. This table exists ONLY so prefsService can migrate
// records written under the old sharp/default/round enum.
//
// sharp → 8px and default → 16px are exact (the old multipliers were 0.5 and 1 against
// a 16px radius.lg). round → 26px vs the old 25.6px — a sub-pixel difference. All three
// sit inside the default 0–32 slider track, so migration never clamps.

import type { RadiusKey } from '@/core/models/preferences';

export const LEGACY_RADIUS_PX: Record<RadiusKey, number> = {
  sharp: 8,
  default: 16,
  round: 26,
};
